module.exports = __webpack_public_path__ + "img/access-icon.83ea55b8.svg";